/* eslint-disable prettier/prettier */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  encompassUserId: null as string | null,
  encompassClientId: null as string | null,
  instanceId: null as string | null,
};

const slice = createSlice({
  name: 'miRequest',
  initialState,
  reducers: {
    setEncompassUserId: (state, { payload }) => {
      state.encompassUserId = payload;
    },
    setEncompassClientId: (state, { payload }) => {
      state.encompassClientId = payload;
    },
    setInstanceId: (state, { payload }) => {
      state.instanceId = payload;
    },
  },
});

export const miRequestActions = slice.actions;
export const selectEncompassClientId = ({eppsData}: any) =>
  eppsData.miRequest.encompassClientId;
export const selectEncompassUserId = ({eppsData}: any) =>
  eppsData.miRequest.encompassUserId;
export const selectInstanceId = ({eppsData}: any) =>
  eppsData.miRequest.instanceId;
export default slice.reducer;
